import _extends from "@babel/runtime-corejs2/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime-corejs2/helpers/esm/objectWithoutProperties";
/**
 *
 * Cell
 *
 */

import React from 'react';
import classnames from 'classnames';

var Cell = function Cell(_ref) {
  var extraClasses = _ref.extraClasses,
      children = _ref.children,
      otherProps = _objectWithoutProperties(_ref, ["extraClasses", "children"]);

  return React.createElement("div", _extends({
    className: classnames('cell', extraClasses)
  }, otherProps), children);
};

Cell.defaultProps = {
  extraClasses: ''
};
Cell.displayName = 'Cell';
export default Cell;